import { render, staticRenderFns } from "./DefaultEmailComplete.vue?vue&type=template&id=ffb93596&lang=pug&"
import script from "./DefaultEmailComplete.vue?vue&type=script&lang=ts&"
export * from "./DefaultEmailComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports